module.exports = __webpack_public_path__ + "img/Wendy@2x.da694734.png";